import { Suspense } from "react";
import { Outlet } from "react-router";

import { AskNobiAmbientBackground } from "@/components/AskNobi/AskNobiAmbientBackground";
import { NavigationSidebar } from "@/components/NavigationSidebar/NavigationSidebar";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";

export function MainLayout({ children }: { children: React.ReactNode }): React.ReactNode {
  return (
    <div className="relative grid h-full grid-rows-[min-content_1fr] md:grid-cols-[auto_minmax(0,1fr)] md:grid-rows-1">
      <NavigationSidebar />
      {children}
    </div>
  );
}

export function AskNobiLayout(): React.ReactNode {
  return (
    <MainLayout>
      <main className="@container relative min-h-full w-full md:min-w-0" id="main">
        <div className="mx-auto size-full max-w-440">
          <AskNobiAmbientBackground />
          <Suspense fallback={<FullSizeLoader withPadding />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </MainLayout>
  );
}

export function StandardPageLayout(): React.ReactNode {
  return (
    <MainLayout>
      <main className="@container min-h-full w-full overflow-auto md:min-w-0" id="main">
        <div className="mx-auto size-full max-w-440">
          <Suspense fallback={<FullSizeLoader withPadding />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </MainLayout>
  );
}
